import { Link } from 'react-router-dom';
import { categoriesMap, type Comic } from '@/mocks/comics';

export default function ComicCard({ comic }: { comic: Comic }) {
  const cat = categoriesMap[comic.category];
  return (
    <Link
      to={`/comic/${comic.id}`}
      data-product-shop
      className="group block overflow-hidden rounded-xl border border-background-200/60 bg-background-100 transition-all duration-300 hover:border-primary-400/60"
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden">
        <img
          src={comic.cover}
          alt={`${comic.title} ${comic.tags.join('、')}漫画封面`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded bg-black/60 px-2 py-0.5 text-[11px] text-foreground-950 backdrop-blur-sm">
          {cat?.name}
        </span>
        {comic.status === '已完结' && (
          <span className="absolute right-2 top-2 rounded bg-secondary-200/90 px-2 py-0.5 text-[11px] text-secondary-950">
            已完结
          </span>
        )}
        <span className="absolute bottom-2 right-2 flex items-center gap-1 rounded bg-black/60 px-2 py-0.5 text-[11px] text-accent-300 backdrop-blur-sm">
          <i className="ri-fire-line" aria-hidden="true"></i>
          {comic.rating}
        </span>
      </div>
      <div className="p-3">
        <h3 className="truncate text-sm font-bold text-foreground-950 transition-colors group-hover:text-primary-400">
          {comic.title}
        </h3>
        <p className="mt-1 truncate text-xs text-foreground-600">
          {comic.latestChapter}
        </p>
        <div className="mt-2 flex items-center justify-between text-[11px] text-foreground-500">
          <span>{comic.views} 人气</span>
          <span className={comic.updateTime === '今日更新' ? 'text-primary-400' : ''}>
            {comic.updateTime}
          </span>
        </div>
      </div>
    </Link>
  );
}